<template>
  <div id="product-menu">
    <!--  タブの下  -->
    <div class="position-fixed">
      <swiper class="buttons"
              :loop="true"
              :currentPage="currentPage"
              @slider-move="onSliderMove"
              @slide-touch-end="onSlideTouchEnd"
              @slide-change-page="onSlideChangePage">
        <div class="infinity-swipe-item" v-for="(button, index) in buttons">
          <button
            :class="{active: currentPage==index+1, disabled: button.disabled}"
            @click="onButtonClick(index+1)">
            {{button.name}}
          </button>
        </div>
      </swiper>
      <div class="marquee"><p>{{marquee}}</p></div>
    </div>

    <div class="product_list">
      <transition name="fade">
        <!--<keep-alive><component v-bind:is="active_tab" @setMarquee="setMarquee"></component></keep-alive>-->
        <router-view @setMarquee="setMarquee"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import Category from './item/Category.vue'
  import ProductFigure from './item/Figure.vue'
  import Design from './item/Design.vue'
  import Color from './item/Color.vue'
  import FontMenu from './item/Font.vue'
  import OrderMenu from './OrderMenu.vue'
  import InfinitySwipe from '../InfinitySwipe.vue'

  export default {
    name: 'Item',
    components: {
      Category,
      ProductFigure,
      Design,
      Color,
      font: FontMenu,
      estimate: OrderMenu,
      swiper: InfinitySwipe,
    },
    data(){
      return {
        category_id: null,
        figure_id: null,
        design_id: null,
        touch_time: 0,
        marquee: 'アイテムを選んでください.'
      }
    },
    computed: {
      ...mapGetters([
        'active_tab',
      ]),
      buttons(){
        return this.$store.state.product_tab.buttons;
      },
      currentPage(){
        const current = this.buttons.find(button => button.code === this.$route.name);
        return this.buttons.indexOf(current) + 1;
      },
    },
    created() {
      // console.log('item created');
      // const buttonPos = this.$store.state.product_tab.buttons.indexOf(
      //   this.$store.state.product_tab.buttons.find(button => button.code === 'design')
      // );
      // this.changeActiveTab(buttonPos);
      // this.$store.commit('disableAfterActiveTab', buttonPos - 1);
    },
    methods: {
      ...mapMutations(['changeActiveTab']),
      ...mapActions(['initializeActiveTab']),
      setMarquee: function(str) {
        this.marquee = str;
      },
      onButtonClick: function(page){
        if (this.touch_time < 300){
          this.onSlideChangePage(page);
        }
      },
      onSlideTouchEnd: function(page, time){
        this.touch_time = time;
        this.onSlideChangePage(page);
      },
      onSlideChangePage: function (page) {
        if (
          this.buttons.length < page ||
          ('disabled' in this.buttons[page - 1]) && this.buttons[page - 1].disabled
        ) {
          return;
        }
        this.$store.commit('changeActiveTab', page - 1);
        const name = this.$store.state.product_tab.buttons[page - 1].code;
        this.category_id = (this.$route.params.category_id) ? this.$route.params.category_id : this.$store.state.cart.category.id;
        this.figure_id = (this.$route.params.figure_id) ?
          this.$route.params.figure_id :
          this.$store.state.cart.figure ? this.$store.state.cart.figure.id : null;
        this.design_id = (this.$route.params.design_id) ?
          this.$route.params.design_id :
          this.$store.state.cart.design ? this.$store.state.cart.design.id : null;
        this.$router.push({name:name, params: {
            category_id: this.category_id,
            figure_id: this.figure_id,
            design_id: this.design_id,
          }
        });

      },
      onSliderMove: function(translate, delta){
        let item_width = 110;
        let page = this.currentPage;
        if (delta < 0){
          page = Math.floor(translate / item_width) * -1 + 1;
        } else {
          page = Math.floor(translate / item_width) * -1;
        }
        if (page <= 0) page = 1;
        if (page > this.buttons.length) page = this.buttons.length + 1;

        if (page != this.currentPage){
          this.onSlideChangePage(page);
        }
      },
    },
    watch: {
      active_tab (val) {
        switch (val) {
          case 'category':
            this.setMarquee('アイテムを選んでください..');
            break;
          case 'product-figure':
            this.setMarquee('タイプを選んでください');
            break;
          case 'design':
            this.setMarquee('デザインを選んでください');
            break;
          case 'color':
            this.setMarquee('カラーを選んでください');
            break;
          case 'font':
            this.setMarquee('オプションを選んでください');
            break;
          case 'estimate':
            this.setMarquee('サイズと数量を選択してください');
            break;
        }
      }
    },
    filters: {
      currency: function (value) {
        return "¥" + value.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,')
      }
    }
  }
</script>

<style lang="scss">
  .position-fixed{
    position: fixed;
    width: 100%;
    height: 76px;
    z-index:99;
  }
  #product-menu .swiper{
    background-color: #151d66;
    width: 100%;
  }
  #product-menu .product_list{
    padding: 76px 0 0 0;
    ul {
      position: relative;
      padding:0;
      margin: 0 0 5px 0;
      li {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        button {
          position: relative;
          border: 1px solid #151d66;
          color: #000;
          width: 110px;
          background-color: #eee;
          background-image: linear-gradient(45deg, silver 25%, transparent 25%, transparent 75%, silver 75%, silver),
          linear-gradient(45deg, silver 25%, transparent 25%, transparent 75%, silver 75%, silver);
          background-size:20px 20px;
          background-position:0 0, 10px 10px;
          &.close {
            background: #151d66;
            height: auto;
            color: white;
            margin-right: 2px;
          }
          &.uk-modal-close-default {
            background: #999999;
            height: 3rem;
            width: 3rem;
            position: absolute;
            color: white;
            border: 0;
            border-radius: 50%;
            >>> svg > path{
              stroke-width: 3px !important;
            }
          }
          &.info {
            width: 20px;
            height: 20px;
            position: absolute;
            background: #151d66;
            color: white;
            top: -2px;
            right: -2px;
            border: 1px solid silver;
          }
        }
      }
    }
    .uk-modal-header{
      text-align: center;
      background: #151d66;
      color: white;
      padding: 1em;
      border-radius: 1em;
      h2{
        color: white;
      }
    }
    .uk-modal-footer{
      text-align: center;
    }
    /* アニメーション後に自動でuk-openがついてくれなくなったので仕方なくvk-modalを自分で実装 */
    .uk-modal.uk-open{
      display:block;
    }
  }
  .buttons{
    overflow: hidden;
  }
  .infinity-swipe-item {
    width: 110px;
    margin: 0;
    text-align: center;
  }

  .infinity-swipe-item > button {
    width: 90%;
    height: 40px;
  }

  .infinity-swipe-item > button.active {
    background-color: transparent;
    border: 0;
    font-weight: bold;
  }

</style>

<style lang="scss" scoped>
  .swiper /deep/ .infinity-swipe-item:not(:last-child) {
    margin-right: 1rem;
    &:after {
      content: '▶︎';
      position: absolute;
      top: 1rem;
    }
  }
  #product-menu /deep/ .VueCarousel button {
    background-image: none;
  }
</style>
